{
  "sidebar": {
    "operators": "Operators",
    "admins": "Admins",
    "formBuilder": "Forms",
    "incidentSubmissions": "Incidents",
    "submittedForms": "Submitted Forms",
    "signOut": "Sign Out",
    "profile": "Profile",
    "companies": "Business Entities",
    "activityLogs": "Activity Logs",
    "avoidedIncidents": "Avoided incidents"
  },
  "common": {
    "yes": "Yes",
    "no": "No",
    "filters": "Filters",
    "apply": "Apply",
    "deletedUser": "Deleted User",
    "deletedEntity": "Deleted",
    "otherNumericInputLabel": "Number of users affected by the incident",
    "errors": {
      "email": "Field must be a valid email address",
      "minlength": "Field must be minimum {{requiredLength}} characters long. Current length is {{actualLength}}",
      "required": "Field is required",
      "maxlength": "Field must be maximum {{requiredLength}} characters. Current length is {{actualLength}}",
      "pattern": "Field must match pattern {{requiredPattern}}",
      "min": "Field must be minimum {{min}}",
      "max": "Field must be maximum {{max}}",
      "websitePattern": "Please enter a valid website URL (e.g., https://example.com)",
      "durationPattern": "Please enter a valid duration in format {{durationLabel}}",
      "startsWith": "Field must start with {{startsWith}} and contain only digits",
      "mustMatchPassword": "Passwords do not match",
      "strongPassword": "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character",
      "pageNotFound": "No form was found",
      "pageNotFoundDescription": "No active forms exist. Please, try again later or contact support.",
      "minDate": "Date must be after {{minDate}}",
      "maxDate": "Date must be before {{maxDate}}",
      "step": "Field must be a multiple of {{step}}",
      "operatorIdMissing": "Selecting an operator is required before filling out the form"
    },
    "toast": {
      "success": "Success",
      "warning": "Warning",
      "error": "Error"
    },
    "actions": "Actions",
    "select": "Select",
    "page": "Page",
    "currentFile": "Current File",
    "newFile": "New File",
    "uploadEmpty": "Click to upload",
    "uploadNewFile": "Upload new file",
    "of": "of",
    "currency": "RSD",
    "hour": "Hour",
    "switchTooltip": "Toggle",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit",
    "back": "Back",
    "noData": "No data",
    "noValue": "No value",
    "performingAction": "Performing action...",
    "otherInputPlaceholder": "Enter other text...",
    "otherAnswerLabel": "Other answer",
    "otherNumberPlaceholder": "Enter number...",
    "enums": {
      "incidentStatus": {
        "status": "Status",
        "REPORTED": "Incident reported",
        "REPORT_SUBMITTED": "Delivered additional notice",
        "ADDITIONAL_REPORT_SUBMITTED": "Additional report submitted",
        "CLOSED": "Closed",
        "DISMISSED": "Dismissed"
      },
      "mediaType": {
        "UNKNOWN": "Unknown",
        "IMAGE": "Image",
        "VIDEO": "Video",
        "SVG": "SVG",
        "AUDIO": "Audio",
        "PDF": "PDF",
        "WORD": "Word Document",
        "ARCHIVE": "Archive"
      }
    },
    "reportType": {
      "title": "What are you reporting?",
      "description": "Choose the type of report to open the matching form.",
      "incident": "Incident",
      "incidentDescription": "An incident that occurred in the ICT system.",
      "avoided": "Avoided incident",
      "avoidedDescription": "An incident that was prevented before it happened.",
      "change": "Change report type",
      "downloadPdf": "Download PDF form"
    }
  },
  "confirmations": {
    "delete": "Delete this item?",
    "submitForm": "Are you sure you want to submit the form?"
  },
  "buttons": {
    "no": "Cancel",
    "yes": "Confirm"
  },
  "fileDownload": {
    "downloading": "Starting file download"
  },
  "auth": {
    "forgotPassword": "Forgot password?",
    "login": "Login",
    "returnToLogin": "Return to login",
    "sendEmail": "Send email",
    "resetPassword": "Reset password",
    "register": "Register",
    "alreadyHaveAccount": "Already have an account?",
    "otpCode": "OTP Code",
    "otpExpiresIn": "Expires in",
    "otpExpired": "OTP expired, please try again",
    "fields": {
      "name": "Name",
      "email": "Email",
      "password": "Password",
      "repeatPassword": "Repeat password"
    }
  },
  "submittedForms": {
    "all": {
      "title": "All Submitted Forms",
      "description": "View and manage all submitted incident forms"
    },
    "single": {
      "title": "Submitted Form Details",
      "description": "View detailed information about the submitted form",
      "submittedBy": "Submitted By",
      "submittedAt": "Submitted At",
      "id": "ID",
      "noFields": "No fields to display",
      "noData": "No data",
      "noDataDescription": "This form does not contain any data to display"
    },
    "filter": {
      "search": "Search",
      "searchPlaceholder": "Search",
      "date": "Date Range",
      "datePlaceholder": "Select date range"
    },
    "fields": {
      "id": "ID",
      "uuid": "UUID",
      "name": "Name",
      "status": "Status",
      "submitted_at": "Submitted At"
    }
  },
  "languagePicker": {
    "en": "English",
    "sr": "Srpski (latinica)",
    "cyr": "Српски (ћирилица)"
  },
  "languages": {
    "en": "English",
    "sr": "Serbian (latin)",
    "cyr": "Serbian (cyrillic)"
  },
  "primeng": {
    "multiselect": {
      "selectedItemsLabel": "{0} items selected"
    }
  }
}
